<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <!-- Scale in from edge-to-edge art so optical size matches other 24px settings icons -->
  <g transform="translate(12 12) scale(0.82) translate(-12 -12)">
    <path
      d="M0.75 23.25V0.75"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M0.75 20.2924L3.904 19.3224C5.21051 18.9202 6.58781 18.8013 7.94392 18.9738C9.30003 19.1462 10.6037 19.606 11.768 20.3224C12.9046 21.0217 14.1743 21.4767 15.4964 21.6585C16.8184 21.8403 18.1638 21.7449 19.447 21.3784L22.434 20.5254C22.669 20.4581 22.8758 20.3161 23.023 20.1209C23.1702 19.9257 23.2499 19.6879 23.25 19.4434V3.63642C23.2498 3.46235 23.2093 3.29068 23.1316 3.1349C23.0539 2.97913 22.9412 2.84349 22.8022 2.73864C22.6632 2.63379 22.5019 2.56259 22.3308 2.53062C22.1596 2.49866 21.9834 2.50681 21.816 2.55442L19.447 3.23142C18.1638 3.59793 16.8184 3.69332 15.4964 3.51152C14.1743 3.32971 12.9046 2.8747 11.768 2.17542C10.6037 1.459 9.30003 0.999214 7.94392 0.826768C6.58781 0.654323 5.21051 0.773187 3.904 1.17542L0.75 2.14442"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 15.75C11.9258 15.75 11.8533 15.772 11.7917 15.8132C11.73 15.8544 11.6819 15.913 11.6535 15.9815C11.6252 16.05 11.6177 16.1254 11.6322 16.1982C11.6467 16.2709 11.6824 16.3377 11.7348 16.3902C11.7873 16.4426 11.8541 16.4783 11.9268 16.4928C11.9996 16.5073 12.075 16.4998 12.1435 16.4715C12.212 16.4431 12.2706 16.395 12.3118 16.3333C12.353 16.2717 12.375 16.1992 12.375 16.125C12.375 16.0255 12.3355 15.9302 12.2652 15.8598C12.1948 15.7895 12.0995 15.75 12 15.75Z"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 12.75V6.75"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
</svg>
